import { MouseEventHandler } from "react";
import { Link } from "react-router-dom";

import { Spinner } from "./spinner";

export function Button({
  type = "button",
  severity = "primary",
  link = false,
  text = false,
  outline = false,
  size = "md",
  children,
  disabled,
  route,
  href,
  target,
  onClick,
  title,
  className,
  loading = false,
}: {
  type?: "submit" | "button";
  severity?: "primary" | "secondary" | "danger";
  link?: boolean;
  text?: boolean;
  outline?: boolean;
  size?: "sm" | "md" | "lg";
  children: React.ReactNode;
  disabled?: boolean;
  route?: string;
  href?: string;
  target?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  title?: string;
  className?: string;
  loading?: boolean;
}) {
  const isDisabled = disabled || loading;
  const backgroundClass =
    link || text || outline
      ? "bg-transparent"
      : severity === "secondary"
        ? "bg-gray-500"
        : severity === "danger"
          ? "bg-red-500"
          : "bg-blue-500";
  const textClass = `${link ? "text-blue-500" : text || outline ? `${severity === "danger" ? "text-red-500" : "text-black"}` : "text-white uppercase"} ${size === "sm" ? "text-xs" : size === "md" ? "text-sm" : "text-base"}`;
  const paddingClass =
    link || text
      ? ""
      : size === "sm"
        ? "px-2 py-1"
        : size === "md"
          ? "px-4 py-2"
          : "px-2 py-1 sm:px-6 sm:py-3";
  const outlineClass = outline
    ? severity === "danger"
      ? "border border-red-500"
      : severity === "secondary"
        ? "border border-gray-500"
        : "border border-blue-500"
    : "";
  if (route) {
    return (
      <Link
        className={`${paddingClass} ${backgroundClass} ${outlineClass} ${textClass} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""} flex items-center relative cursor-pointer rounded-md ${className ?? ""}`}
        title={title}
        to={route}
      >
        <ButtonContent loading={loading}>{children}</ButtonContent>
      </Link>
    );
  }
  if (href) {
    return (
      <a
        className={`${paddingClass} ${backgroundClass} ${outlineClass} ${textClass} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""} flex items-center relative cursor-pointer rounded-md ${className ?? ""}`}
        href={href}
        target={target}
        title={title}
      >
        <ButtonContent loading={loading}>{children}</ButtonContent>
      </a>
    );
  }

  return (
    <button
      className={`${paddingClass} ${backgroundClass} ${outlineClass} ${textClass} flex items-center relative cursor-pointer rounded-md disabled:opacity-50 disabled:cursor-not-allowed ${className ?? ""}`}
      disabled={isDisabled}
      title={title}
      type={type}
      onClick={onClick}
    >
      <ButtonContent loading={loading}>{children}</ButtonContent>
    </button>
  );
}

function ButtonContent({
  loading,
  children,
}: {
  loading?: boolean;
  children: React.ReactNode;
}) {
  return (
    <>
      <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
        {loading && <Spinner />}
      </div>
      <div className={loading ? "opacity-0" : ""}>{children}</div>
    </>
  );
}
